/**
 * SubscribeUserDisclaimers
 *
 * Renders the policy disclaimer (plain text, no link — the policy screen port
 * is a separate ticket) plus the test-mode auto-renew disclaimer when
 * `remoteConfigService.isTestMode` is true — Flutter's
 * `RemoteConfigService.isTestMode` gate (subscribe_user_bottom_sheet.dart:549).
 */
import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { remoteConfigService } from '@/domain/services/remoteConfig/remoteConfigService';

export const SubscribeUserDisclaimers: React.FC = () => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();
  const { l10n } = useLocale();

  return (
    <div className="flex flex-col" style={{ gap: responsive.spacing.xs }}>
      <span
        style={{
          color: theme.text.secondary,
          fontSize: responsive.font.sm,
          textAlign: 'center',
          paddingLeft: responsive.spacing.base,
          paddingRight: responsive.spacing.base,
        }}
      >
        {l10n.subscribeUser.policyDisclaimerPrefix}
        {/* TODO: render policyDisclaimerLinkText as a link once the Exclusive Subscriptions Policy screen is ported (deferred to a separate ticket). */}
        {l10n.subscribeUser.policyDisclaimerLinkText}
      </span>

      {/*
        Live Remote Config value, falling back to the compile-time default when no
        template has activated yet. The web default is `false` and the paired Flutter
        change on this branch flips Flutter's `RemoteConfigsDefaults.isTestMode` to
        `false` too, so the two clients now agree; the server template already says
        `false`, so live behaviour is unchanged either way.
      */}
      {remoteConfigService.isTestMode && (
        <span
          style={{
            color: theme.text.secondary,
            fontSize: responsive.font.xs,
            fontStyle: 'italic',
            textAlign: 'center',
            paddingLeft: responsive.spacing.base,
            paddingRight: responsive.spacing.base,
          }}
        >
          {l10n.subscribeUser.testModeAutoRenewDisclaimer}
        </span>
      )}
    </div>
  );
};
